import { render } from "./header_app.vue?vue&type=template&id=a2e42530"
const script = {}

import "./header_app.vue?vue&type=style&index=0&id=a2e42530&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__